<p-dialog
  [(visible)]="visible"
  [header]="config.title"
  [modal]="true"
  [closable]="!loading"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="!loading"
  [dismissableMask]="!loading"
  [style]="{ width: '90vw', maxWidth: '500px' }"
  styleClass="confirmation-dialog"
  (onHide)="onHide()">

  <!-- Dialog Content -->
  <div class="dialog-content space-y-6">
    <!-- Warning Message -->
    <div [class]="'p-4 rounded-lg border ' + messageClass">
      <div class="flex items-start space-x-3">
        <i class="pi pi-exclamation-triangle text-xl flex-shrink-0 mt-0.5"
           [class.text-red-600]="config.severity === 'danger'"
           [class.text-orange-600]="config.severity === 'warn'"
           [class.text-green-600]="config.severity === 'success'"
           [class.text-blue-600]="config.severity === 'info'">
        </i>
        <div class="flex-1">
          <p class="font-medium text-sm leading-relaxed">
            {{ config.message || 'Esta acción no se puede deshacer. Confirme ingresando el código del aliado exacto.' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Code Input Section -->
    <div class="space-y-3">
      <div class="space-y-2">
        <label for="code-input" class="block text-sm font-medium text-gray-700">
          {{ config.codeLabel || 'Código' }}
        </label>
        <div class="relative">
          <input
            id="code-input"
            type="text"
            pInputText
            [(ngModel)]="enteredCode"
            (input)="onCodeInput()"
            [placeholder]="config.expectedCode ? 'Ingrese: ' + config.expectedCode : 'Ingrese el código'"
            [disabled]="loading"
            class="w-full font-mono text-center tracking-wider"
            [class.p-invalid]="showCodeError && config.expectedCode"
            autocomplete="off"
            maxlength="20">
          <!-- Input validation icon solo si hay expectedCode -->
          <div class="absolute right-3 top-1/2 transform -translate-y-1/2" *ngIf="config.expectedCode">
            <i *ngIf="enteredCode && isValidCode"
               class="pi pi-check text-green-500 text-sm"></i>
            <i *ngIf="enteredCode && !isValidCode"
               class="pi pi-times text-red-500 text-sm"></i>
          </div>
        </div>
        <!-- Expected code hint solo si hay expectedCode -->
        <div class="bg-gray-50 p-3 rounded-md border" *ngIf="config.expectedCode">
          <p class="text-xs text-gray-600">
            <span class="font-medium">Código esperado:</span>
            <span class="font-mono ml-2 bg-white px-2 py-1 rounded border">{{ config.expectedCode }}</span>
          </p>
        </div>
      </div>
      <!-- Error Message solo si hay expectedCode -->
      <div *ngIf="showCodeError && config.expectedCode" class="bg-red-50 border border-red-200 rounded-md p-3">
        <div class="flex items-center space-x-2">
          <i class="pi pi-times-circle text-red-500 text-sm"></i>
          <p class="text-red-700 text-xs font-medium">
            El código ingresado no coincide. Verifique e intente nuevamente.
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Dialog Footer -->
  <ng-template pTemplate="footer">
    <div class="flex flex-col sm:flex-row gap-3 pt-4">
      <!-- Cancel Button -->
      <p-button
        [label]="config.cancelButtonLabel || 'Cancelar'"
        icon="pi pi-times"
        styleClass="p-button-outlined p-button-secondary flex-1"
        [disabled]="loading"
        (onClick)="onCancel()">
      </p-button>
      <!-- Confirm Button -->
      <p-button
        [label]="config.confirmButtonLabel || 'Confirmar'"
        [icon]="config.confirmButtonIcon || 'pi pi-check'"
        [styleClass]="confirmButtonClass + ' flex-1'"
        [disabled]="config.expectedCode ? !isValidCode : !isEmissionCodeValid"
        [loading]="loading"
        (onClick)="onConfirm()">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
